import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "../";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const prefillEmploymentCertificate = personId => {
  return dispatch => {
    dispatch({ type: "GET_PREFILL_EMPLOYMENT_CERTIFICATE_LOADING" });
    api
      .prefillEmploymentCertificateGet(personId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
      })
      .catch(e => {
        jsError(e);
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "FetchPrefillEmploymentCertificateErrorAlertTitle",
          "Virhe työtodistusten tietojen alustamisessa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_PREFILL_EMPLOYMENT_CERTIFICATE_SUCCEEDED",
  payload: { employmentCertificate: data },
});

const operationFail = () => ({
  type: "GET_PREFILL_EMPLOYMENT_CERTIFICATE_FAIL",
});
